import { Flex } from "common/components/flex/flex";
import { Tooltip } from "common/components/tooltip/tooltip";
import { MetricIconBadge } from "features/dashboard/components/metricIconBadge/metricIconBadge";
import { FileTimesIcon } from "features/dashboard/sections/postOfferMetrics/icons/FileTimesIcon";
import { UserTimesIcon } from "features/dashboard/sections/postOfferMetrics/icons/UserTimesIcon";
import { MetricItem } from "features/dashboard/components/metricItem/metricItem";
import * as styles from "features/dashboard/sections/postOfferMetrics/falloutRates/falloutRates.module.scss";

const calculateRate = (numerator, denominator) => {
  if (denominator === 0) return 0;
  return (numerator / denominator) * 100;
};

const formatPercentage = (value) => {
  if (value === 0) return "0%";
  return `${value.toFixed(1)}%`;
};

const FalloutRatesSkeleton = () => {
  return (
    <Flex justify="space-between">
      {[0, 1].map((index) => (
        <MetricItem.Skeleton
          key={index}
          labelHeight={28}
          className={styles.falloutRates__item}
        />
      ))}
    </Flex>
  );
};

export const FalloutRates = ({
  offerFallouts = 0,
  offersExtended = 0,
  interviewNoShows = 0,
  interviewsScheduled = 0,
  loading = false,
}) => {
  const offerFalloutRate = calculateRate(offerFallouts, offersExtended);
  const interviewNoShowRate = calculateRate(
    interviewNoShows,
    interviewsScheduled,
  );

  const rates = [
    {
      label: "Offer Fallout Rate",
      value: formatPercentage(offerFalloutRate),
      icon: <FileTimesIcon />,
      iconColor: "var(--red-200)",
      iconBgColor: "var(--red-200-10)",
      description:
        "The percentage of extended offers this month that did not result in a candidate starting with the client.",
    },
    {
      label: "Interview No Show Rate",
      value: formatPercentage(interviewNoShowRate),
      icon: <UserTimesIcon />,
      iconColor: "var(--orange-300)",
      iconBgColor: "var(--orange-300-10)",
      description:
        "The percentage of scheduled interviews this month that candidates did not attend.",
    },
  ];

  if (loading) {
    return <FalloutRatesSkeleton />;
  }

  return (
    <Flex justify="space-between">
      {rates.map((rate) => (
        <Tooltip key={rate.label} title={rate.description}>
          <MetricItem
            label={rate.label}
            icon={
              <MetricIconBadge
                icon={rate.icon}
                color={rate.iconColor}
                bgColor={rate.iconBgColor}
              />
            }
            className={styles.falloutRates__item}
          >
            <MetricItem.Value>{rate.value}</MetricItem.Value>
          </MetricItem>
        </Tooltip>
      ))}
    </Flex>
  );
};
